// Pre-fetch all media-gallery <img> resources after window.load + idle.
//
// The gallery uses loading="lazy" so non-visible variant images don't compete
// with LCP — but that means when a customer switches variants and
// setActiveMedia makes a different <li> active, the <img> inside it might
// not be downloaded yet. The browser fetches it on-demand and the customer
// sees a brief blank/old-image moment before the new image paints.
//
// By creating an offscreen `new Image()` with the same srcset + sizes after
// the page is idle, we trigger the browser to fetch the resource at low
// priority and cache it in the HTTP cache. When the lazy <img> in the
// gallery is later told to load (via setActiveMedia making it `is-active`),
// the fetch resolves from cache instantly — no network roundtrip, no
// visible delay.
//
// Image responses (unlike Section Rendering API responses) ARE cacheable
// in the browser HTTP cache; CDN sends Cache-Control: max-age=... and no
// Set-Cookie. So we don't need an in-memory cache — the browser handles
// it once we've kicked off the request.

(function () {
  function preloadGalleryImages() {
    var images = document.querySelectorAll('media-gallery img');
    var warmed = 0;
    images.forEach(function (img) {
      // Skip the eager (LCP) image — already downloaded.
      // Skip anything already complete (cached, or eager-loaded).
      if (img.loading === 'eager') return;
      if (img.complete && img.naturalWidth > 0) return;

      var preloader = new Image();
      preloader.decoding = 'async';
      // Preserve srcset + sizes so the browser picks the SAME URL the
      // gallery <img> would pick when shown. Set src last so the browser
      // doesn't kick off two fetches.
      if (img.srcset) preloader.srcset = img.srcset;
      if (img.sizes) preloader.sizes = img.sizes;
      if (img.src) preloader.src = img.src;
      warmed++;
    });
    if (warmed > 0 && window.console && console.debug) {
      console.debug('[variant-image-preload] warmed', warmed, 'gallery images');
    }
  }

  function schedule() {
    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return setTimeout(cb, 1000);
      };
    idle(preloadGalleryImages, { timeout: 3000 });
  }

  // Expose so any context that injects a <media-gallery> via Section
  // Rendering API after page load can re-trigger the scan once it's
  // mounted. Idempotent — the per-image guard skips already-complete
  // images and Image() with the same src is a no-op for the browser
  // when the resource is in HTTP cache.
  window.__variantImagePreloadRun = schedule;

  // Auto-run once on initial page load — guarded so a second load of
  // this script on the same page doesn't double-schedule.
  if (window.__variantImagePreloadStarted) return;
  window.__variantImagePreloadStarted = true;

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
